var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpiresIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3573 4.45464C14.4586 6.55594 14.4666 9.9458 12.3863 12.0261C10.306 14.1064 6.9161 14.0984 4.8148 11.9971L4.06056 12.7514C6.57345 15.2643 10.6387 15.2822 13.1405 12.7804C15.6424 10.2785 15.6244 6.21329 13.1115 3.70039C10.5986 1.1875 6.53338 1.16955 4.03155 3.67138C3.51784 4.18509 3.05642 4.88352 2.7299 5.55185L2.42155 4.89224L1.45526 5.34396L2.64139 7.88127L4.97592 6.42441L4.41121 5.51949L3.72373 5.94851C4.00198 5.3959 4.38308 4.82834 4.78579 4.42563C6.86612 2.34531 10.256 2.35334 12.3573 4.45464ZM4.21088 11.2797C3.96235 10.9266 3.76121 10.5507 3.60737 10.1607L2.61511 10.5521C2.79959 11.0198 3.0408 11.4705 3.3386 11.8937L4.21088 11.2797Z",
    fill: "#00BAC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 5.86621H9.06667V8.27654L11.5332 10.2497L10.8668 11.0827L8 8.78921V5.86621Z",
    fill: "#00BAC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpiresIcon);
export default __webpack_public_path__ + "static/media/expires-icon.860d4f4c06c050c213b99684225e200e.svg";
export { ForwardRef as ReactComponent };